import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { DatePipe, SlicePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";

import { ENV } from "../../../../app.runtime";
import { DEFAULT_LANGUAGE } from "../../../../constants";
import { GetNewsItemLink, NewsItem } from "../../../domain/schemas/news-item";

@Component({
  selector: "news-headers",
  templateUrl: "./news-headers-list.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, DatePipe, SlicePipe, TranslatePipe, GetNewsItemLink],
})
export class NewsHeaders {
  private translate = inject(TranslateService);
  protected newsItems = input<NewsItem[]>([]);

  protected currentLang = computed(() => this.translate.currentLang() ?? DEFAULT_LANGUAGE);
  protected hasNewsItems = computed(() => this.newsItems().length > 0);

  newsUrl = ENV.NWD_NEWS_URL;
}
